import getCurrentFiscalEntity from './contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider/getCurrentFiscalEntity';
import getFiscalEntitiesFromInterval from './contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider/getFiscalEntitiesFromInterval';

const fixedDateRangeToDateRange = (
  relativeDateRange: RelativeDateRange,
  interval: FiscalInterval,
  fiscalRanges?: FixedPeriods.AllFiscals,
): DateRangeInput => {
  if (!fiscalRanges) {
    const e = new Error();
    e.name = 'Cannot use fiscal interval without fiscal ranges';
    throw e;
  }
  const { type, n, currentToDate } = relativeDateRange;

  const fiscalEntities = getFiscalEntitiesFromInterval(interval, fiscalRanges);
  if (!fiscalEntities) {
    const e = new Error();
    e.name = `Unknown fiscal interval: ${interval}`;
    throw e;
  }

  const currentFiscalEntity = getCurrentFiscalEntity(fiscalEntities);
  const entityIndex = fiscalEntities.findIndex(
    (entity) => entity.id === currentFiscalEntity?.id,
  );
  if (type === 'current' || !n) {
    return {
      startDate: currentFiscalEntity?.startDate,
      endDate: currentFiscalEntity?.endDate,
    };
  }
  if (type === 'last') {
    const startIndex = entityIndex - n > 0 ? entityIndex - n : 0;
    return {
      startDate: fiscalEntities[startIndex].startDate,
      endDate: currentToDate
        ? currentFiscalEntity?.endDate
        : fiscalEntities[entityIndex - 1].endDate,
    };
  } else if (type === 'next') {
    const endIndex =
      entityIndex + n < fiscalEntities.length
        ? entityIndex + n
        : fiscalEntities.length - 1;

    return {
      startDate: currentToDate
        ? currentFiscalEntity?.startDate
        : fiscalEntities[entityIndex + 1].startDate,
      endDate: fiscalEntities[endIndex].endDate,
    };
  } else {
    const error = new Error();
    error.name = `FixedDateRange: Unknown fixed date type: ${type}`;
    throw error;
  }
};

export default fixedDateRangeToDateRange;
